import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const CertificateBadge = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg width={`${size}px`} height={`${size}px`} fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        d="M6.5 2.991h60c3.324 0 6 2.676 6 6V50.11c0 3.324-2.676 6-6 6h-60c-3.324 0-6-2.676-6-6V8.99c0-3.324 2.676-6 6-6Z"
        fill="#596379"
      />
      <Path
        d="M17.598 8.825c-.955 0-2.275.716-2.275 2.549 0 3.684-1.874 5.417-6.554 5.417-1.09 0-2.311.893-2.311 2.195V40.12c0 1.302 1.221 2.195 2.31 2.195 4.68 0 6.555 1.733 6.555 5.417 0 1.833 1.32 2.55 2.275 2.55h37.804c.955 0 2.275-.717 2.275-2.55 0-3.684 1.874-5.417 6.554-5.417 1.09 0 2.311-.893 2.311-2.195V18.986c0-1.302-1.221-2.195-2.31-2.195-4.68 0-6.555-1.733-6.555-5.417 0-1.833-1.32-2.55-2.275-2.55H17.598Z"
        fill="#8691A8"
      />
      <Path
        d="m41.261 49.285.042 16.503c.005 2.426 1.749 3.768 3.91 3.008l5.687-1.999 5.687 2c2.16.759 3.904-.583 3.909-3.009l.042-16.503c.004-1.823-19.28-1.823-19.277 0Z"
        fill="#FF6B6B"
      />
      <Path
        d="M24.032 37.797a3 3 0 0 1-3.003-2.999 3 3 0 0 1 3.003-2.998h24.94a3 3 0 0 1 2.999 2.998 3 3 0 0 1-2.999 2.999h-24.94Z"
        fill="#fff"
      />
      <Path
        d="M50.9 33.523c6.528 0 11.82 5.292 11.82 11.82 0 6.528-5.292 11.82-11.82 11.82-6.528 0-11.82-5.292-11.82-11.82 0-6.528 5.292-11.82 11.82-11.82Z"
        fill="#FECA57"
      />
      <Path
        d="M19.576 27c-2.25.001-4.075-1.342-4.076-3 .001-1.659 1.826-3.002 4.076-3H53.43c2.248 0 4.07 1.343 4.07 3-.001 1.656-1.822 2.999-4.07 3H19.576Z"
        fill="#fff"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(.5)" d="M0 0h72v72H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CertificateBadge
